<script lang="ts" setup>
import { AppCircleCheckbox } from '@libs/ui';
import type { FerryTicketCategory } from '@libs/trip-planner-interfaces';

import FerryCardTicket from './FerryCardTicket.vue';

interface FerryCardUpsellProps {
  baseTicketPrice: number;
  tickets: FerryTicketCategory[];
  selectedTicketType: string;
  printMode?: boolean;
}

const props = defineProps<FerryCardUpsellProps>();

interface FerryCardTicketEmits {
  (eventName: 'select-ticket-category', category: string): void;
}

const emit = defineEmits<FerryCardTicketEmits>();
</script>

<template>
  <div class="ferry-card-upsell">
    <FerryCardTicket
      v-for="ticket in props.tickets"
      :key="ticket.token"
      :base-ticket-price="baseTicketPrice"
      :ticket="ticket"
      :selected-ticket-type="selectedTicketType"
      @select-ticket-category="emit('select-ticket-category', $event)"
    />

    <div
      v-if="props.tickets.length === 0"
      class="ferry-card-default-ticket"
      :class="{ 'print-mode': props.printMode }"
    >
      <div class="ticket-radio">
        <AppCircleCheckbox :checked="true" theme="radio" />
      </div>
      <div class="ticket-type">
        <span>{{ props.selectedTicketType }}</span>
        <span class="included">{{ $t('planner.included') }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ferry-card-upsell {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  justify-content: center;

  .ferry-card-default-ticket {
    display: flex;
    gap: var(--spacing-12);
    padding: var(--spacing-12);
    align-items: center;
    justify-content: space-between;
    border-radius: var(--border-radius-8);
    &:not(.print-mode) {
      cursor: pointer;
    }

    .ticket-type {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      gap: var(--spacing-4);
      @include font-label-s-light;
      color: var(--color-neutral-70);

      .included {
        color: var(--color-neutral-70);
        @include font-label-m-bold;
      }
    }
  }
}
</style>
